/* eslint-disable */
var GoSubWidget = (function () {
  function GoSubWidget() {
    this.attrs = {
      purchaseOptionOneTime: "data-gosub-purchase-option-one-time",
      sellingPlanGroupId: "data-gosub-selling-plan-group-id",

      sellingPlanIdInput: "data-gosub-selling-plan-id-input",

      widget: "data-gosub-product",
      sellingPlanOptionsContainer: "data-gosub-selling-plan-options-container",
      sellingPlanOption: "data-gosub-selling-plan-option",
      sellingPlansContainer: "data-gosub-selling-plans-container",
      sellingPlanGroup: "data-gosub-selling-plan-group",
      sellingPlanGroupInput: "data-gosub-selling-plan-group-input",
      sellingPlan: "data-gosub-selling-plan",
      sellingPlanInput: "data-gosub-selling-plan-input",
      productJson: "data-gosub-product-json",
      groupDiscountSummary: "data-gosub-group-discount-summary",
      perDeliveryPrice: "data-gosub-per-delivery-price",
      cartPopupDetails: "data-gosub-cart-popup-details",
      cartPageDetails: "data-gosub-cart-page-details",
      moneyFormat: "data-gosub-money-format",
      pageTemplate: "data-gosub-page-template",
    };

    this.selectors = {
      productForm: 'form[action*="/cart/add"]',
      variantIdInput: '[name="id"]',
      variantSelector: [
        "#shappify-variant-id",
        ".single-option-selector",
        "select[name=id]",
        "input[name=id]",
      ],
      sellingPlanGroupButton: ".gosub-widget__group",
      priceDiv: [
        ".product .price__container",
        '[ref="priceContainer"]',
        ".product price-list",
      ],
    };
    // autogenerate selectors from attributes
    Object.entries(this.attrs).forEach(
      function ([key, value]) {
        this.selectors[key] = `[${value}]`;
      }.bind(this)
    );

    this.classes = {
      hidden: "gosub__hidden",
      selected: "gosub__plan-selected",
    };

    this.products = {};
    this.variants = {};
    this.sellingPlanGroups = {};
    this.pageTemplate = "";
  }

  GoSubWidget.prototype = Object.assign({}, GoSubWidget.prototype, {
    // 引数のwidgetはoptional
    // なければwindow.document.querySelector(this.selectors.widget)を取得.あれば引数のwidget
    // quickModalでテーマから呼ぶ場合にテーマによっては引数が必要になる。
    init: function (widget) {
      console.debug("GORIDE SUBSCRIPTION LOADING...");
      if (!document.querySelector(this.selectors.widget)) {
        console.debug("GORIDE SUB SKIPPED LOADING");
        return;
      }
      this._parsePageTemplate();
      this._parseProductJson();
      this._addVariantChangeListener();
      const productForms = document.querySelectorAll(
        this.selectors.productForm
      );

      productForms?.forEach((form) => {
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;

        let lastValue = variantInput.value;

        new MutationObserver(() => {
          if (variantInput.value !== lastValue) {
            lastValue = variantInput.value;
            var widget = form?.querySelector(this.selectors.widget);
            this._renderPrices(widget);
          }
        }).observe(variantInput, {
          attributes: true,
          attributeFilter: ["value"],
        });
      });

      var widgets =
        widget && widget.length
          ? widget
          : document.querySelectorAll(this.selectors.widget);
      widgets.forEach(
        function (widget) {
          this._renderPrices(widget);
          this._translateContent(widget);
          this._checkPlanLimit(widget);
          // this._renderGroupDiscountSummary(widget)
        }.bind(this)
      );

      window.addEventListener(
        "pageshow",
        function () {
          this.syncAllVisuallySelected();
        }.bind(this)
      );

      productForms?.forEach((form) => {
        const widget = document.querySelector(".gosub-widget__wrapper");
        const observer = new MutationObserver(() => {
          if (widget) {
            this._handlePriceDivChange(widget);
          }
        });

        observer.observe(form, { childList: true, subtree: true });
        if (widget) this._handlePriceDivChange(widget);
      });

      console.debug("GORIDE SUBSCRIPTION LOAD SUCCESSFUL");
    },

    /**
     * Set the hidden selling_plan input to the visually selected plan in the widget.
     * The browser caches form state between back and forward navigations, but doesn't emit change events.
     */
    syncAllVisuallySelected: function () {
      var widgets = document.querySelectorAll(this.selectors.widget);
      widgets.forEach(this._syncVisuallySelected.bind(this));
    },

    _syncVisuallySelected: function (widget) {
      var selectedGroupEl = widget.querySelector(
        `${this.selectors.sellingPlanGroupInput}:checked`
      );
      selectedGroupEl.dispatchEvent(new Event("change"));
    },

    _addVariantChangeListener: function () {
      var selectors = document.querySelectorAll(
        this.selectors.variantSelector.join()
      );
      selectors.forEach(
        function (select) {
          if (select) {
            select.addEventListener(
              "change",
              function (event) {
                var productForm = event.target.closest(
                  this.selectors.productForm
                );
                if (!productForm) console.log("product form not found");
                var widget = productForm?.querySelector(this.selectors.widget);

                // NOTE: Variant change event needs to propagate to `input[name=id]`, so wait for that to happen...
                setTimeout(
                  function () {
                    this._renderPrices(widget);
                    // this._renderGroupDiscountSummary(widget)
                  }.bind(this),
                  100
                );
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },

    _parsePageTemplate: function () {
      var pageTemplateInputEl = document.querySelector(
        this.selectors.pageTemplate
      );
      if (pageTemplateInputEl === null) {
        return;
      }
      this.pageTemplate = pageTemplateInputEl.value;
    },

    _parseProductJson: function () {
      var productJsonElements = document.querySelectorAll(
        this.selectors.productJson
      );

      productJsonElements.forEach(
        function (element) {
          var productJson = JSON.parse(element.innerHTML);
          this.products[element.dataset.gosubProductId] = productJson;

          productJson.selling_plan_groups.forEach(
            function (sellingPlanGroup) {
              this.sellingPlanGroups[sellingPlanGroup.id] = sellingPlanGroup;
            }.bind(this)
          );

          productJson.variants.forEach(
            function (variant) {
              this.variants[variant.id] = variant;
            }.bind(this)
          );
        }.bind(this)
      );
    },

    renderAllPrices: function () {
      console.log("widgets renderAllPrices");
      var widgets = document.querySelectorAll(this.selectors.widget);
      widgets.forEach(this._renderPrices.bind(this));
    },

    /**
     * Display "price / delivery" for each plan label.
     * Should run again if variant changes.
     */
    _renderPrices: function (widget) {
      // Check, product.selling_plan_groups.size > 1
      const isMultiGroup = document
        .querySelector("div.gosub-widget__wrapper")
        .classList.contains("gosub-widget__wrapper--multi-group");
      if (typeof widget === "undefined" || widget === null) {
        widget = document.querySelector(this.selectors.widget);
      }
      var planRadioEls = widget.querySelectorAll(this.selectors.sellingPlan);
      var variantId = this._getVariantId(widget);

      if (variantId) {
        planRadioEls.forEach(
          function (element) {
            var sellingPlanId = element.dataset.gosubSellingPlanId;
            var sellingPlanAllocation = this._getSellingPlanAllocation(
              variantId,
              sellingPlanId
            );
            // sets prices & hides the subscription option if it is not available for some variants.
            var subscriptionOption = document.getElementsByClassName(
              "gosub-widget__group"
            )[1];
            var subscriptionList = document.getElementsByClassName(
              "gosub-widget__plans-container"
            )[0];
            var priceEl = element.querySelector(
              this.selectors.perDeliveryPrice
            );
            if (sellingPlanAllocation != undefined) {
              // varinatにsubscriptionが割り当てられているoption
              if (isMultiGroup) {
                element.classList.remove(this.classes.hidden);
              } else {
                if (subscriptionOption != undefined) {
                  subscriptionOption.classList.remove(this.classes.hidden);
                  if (
                    subscriptionList != undefined &&
                    !widget.querySelector("input[value=once]")?.checked
                  ) {
                    subscriptionList.classList.remove(this.classes.hidden);
                  }
                }
              }
              var price = sellingPlanAllocation.per_delivery_price;
              var formattedPrice = this._formatPrice(price);
              priceEl.innerHTML = formattedPrice;
            } else {
              // varinatにsubscriptionが割り当てられてないoption
              if (isMultiGroup) {
                element.classList.add(this.classes.hidden);
              } else {
                subscriptionOption.classList.add(this.classes.hidden);
              }
              //document.querySelectorAll("input[value=once]")[0]?.click();
              subscriptionList.classList.add(this.classes.hidden);
            }
          }.bind(this)
        );
        if (isMultiGroup) {
          const allOptions = document.querySelectorAll(
            ".gosub-widget__plans-container"
          );
          const gosubBlock = document.querySelector("fieldset.gosub-product");
          const subscriptionButton = document.querySelector(
            ".gosub-widget__groups-container .gosub-widget__group:last-child"
          );
          gosubBlock.classList.remove("gosub__hidden");
          subscriptionButton.classList.remove("gosub__hidden");
          if (
            document
              .querySelector(".gosub-widget__groups-container")
              .classList.contains("default-subscription-selected")
          ) {
            document.querySelectorAll("input[value=subscription]")[0]?.click();
          }
          for (const option of allOptions) {
            option.classList.remove("gosub__hidden");
          }
          // if no active option in group, hide group.
          const planGrups = document.querySelectorAll(
            ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
          );
          for (const group of planGrups) {
            const activeOption = group.querySelector(
              ".gosub-widget__plan:not(.gosub__hidden)"
            );
            if (!activeOption) {
              group.classList.add("gosub__hidden");
            }
          }
          const activeplanGrup = document.querySelector(
            ".gosub-widget__plans-container.gosub-widget__plans-container__multiple:not(.gosub__hidden)"
          );
          if (!activeplanGrup) {
            gosubBlock.classList.add("gosub__hidden");
            subscriptionButton.classList.add("gosub__hidden");
            document.querySelectorAll("input[value=once]")[0]?.click();
          }
          // set sellingPlan searchParms
          const groupSelectedId =
            document
              .querySelector("input[data-gosub-selling-plan-input]:checked")
              ?.closest(".gosub-widget__plans-container") ||
            document.querySelector(".gosub-widget__plans-container");
          const groupId = groupSelectedId.dataset.gosubSellingPlanGroupId;
          const buyMethod = document.querySelector(
            ".gosub-widget__group.gosub__plan-selected input"
          ).value;
          let sellingPlanId =
            buyMethod === "once"
              ? ""
              : this._getActiveSellingPlanId(widget, groupId);

          if (sellingPlanId) {
            console.log("adjusting labels");
            // handle multiple or no active labels for group
            const activeLabelInActiveGroup = activeplanGrup?.querySelectorAll(
              ".gosub-widget__plan-label.active"
            );
            const labelsInActiveGroup = activeplanGrup?.querySelectorAll(
              ".gosub-widget__plan-label"
            );
            if (activeLabelInActiveGroup?.length > 1) {
              console.log(
                "multiple active labels in active group, remove extra actives"
              );
              for (const label of activeLabelInActiveGroup) {
                const input = label.querySelector(
                  "input[data-gosub-selling-plan-input]"
                );
                if (input?.value !== sellingPlanId)
                  label.classList.remove("active");
              }
            } else if (activeLabelInActiveGroup?.length == 0) {
              console.log("no active label in active group, set active one");
              for (const label of labelsInActiveGroup) {
                const input = label.querySelector(
                  "input[data-gosub-selling-plan-input]"
                );
                if (input?.value == sellingPlanId)
                  label.classList.add("active");
              }
            }

            // select first input if no input is selected in active group
            const selectedInputInActiveGroup = activeplanGrup?.querySelectorAll(
              "input[data-gosub-selling-plan-input]:checked"
            );
            if (selectedInputInActiveGroup?.length == 0) {
              const allInputs = activeplanGrup?.querySelectorAll(
                "input[data-gosub-selling-plan-input]"
              );
              if (allInputs?.length > 0) {
                allInputs[0].checked = true;
                sellingPlanId = allInputs[0].value;
                const firstLabel = allInputs[0].closest(
                  ".gosub-widget__plan-label"
                );
                firstLabel.classList.add("active");
              }
            }

            // handle multiple active labels in document
            const activeLabels = document?.querySelectorAll(
              ".gosub-widget__plan-label.active"
            );
            if (activeLabels?.length > 1) {
              for (const label of activeLabels) {
                const input = label.querySelector(
                  "input[data-gosub-selling-plan-input]"
                );
                if (!input?.checked) label.classList.remove("active");
              }
            }

            // handle multiple checked inputs in document
            const allActiveInputs = document?.querySelectorAll(
              "input[data-gosub-selling-plan-input]:checked"
            );
            if (allActiveInputs?.length > 1) {
              for (const input of allActiveInputs) {
                if (input.value !== sellingPlanId) {
                  input.checked = false;
                  const label = input.closest(".gosub-widget__plan-label");
                  label.classList.remove("active");
                }
              }
            }
          }
          if (buyMethod === "once") {
            const plansContainer = document.getElementById(
              "gosub-widget__plans-container-wrapper"
            );
            plansContainer.classList.add(this.classes.hidden);
          }
          this._setSellingPlanIdInput(widget, sellingPlanId);
        } else {
          const gosubBlock = document.querySelector("fieldset.gosub-product");
          const subscriptionButton = document.querySelector(
            ".gosub-widget__groups-container .gosub-widget__group:last-child"
          );
          gosubBlock.classList.remove("gosub__hidden");
          if (
            document
              .querySelector(".gosub-widget__groups-container")
              .classList.contains("default-subscription-selected")
          ) {
            document.getElementById("inputSubscription")?.click();
          }
          if (subscriptionButton.classList.contains("gosub__hidden")) {
            console.log(
              "subscription plan is null in this variant, so hide select buttons"
            );
            gosubBlock.classList.add("gosub__hidden");
            document.querySelectorAll("input[value=once]")[0]?.click();
          }
          // set sellingPlan searchParms
          const groupId = document.querySelector(
            ".gosub-widget__group.gosub__plan-selected input"
          ).value;
          const sellingPlanId =
            groupId === "once"
              ? ""
              : this._getActiveSellingPlanId(widget, groupId);
          this._setSellingPlanIdInput(widget, sellingPlanId);
        }

        // discount description change
        const discountDescriptions = document.querySelectorAll(
          ".gosub-discount-descriptions-container div"
        );
        discountDescriptions.forEach((description) => {
          description.classList.add("gosub__hidden");
        });
        const currentPlansContainer = document
          .querySelector(".gosub-widget__plan-label.active")
          .closest(".gosub-widget__plans-container");
        const currentWidget = document
          .querySelector(".gosub-widget__plan-label.active")
          .closest(".gosub-widget__plan");

        const currentCycle = currentWidget.dataset.gosubSellingPlanCycle;
        const currentName = currentWidget.dataset.gosubSellingPlanName;
        const activeDiscountDescription = currentPlansContainer.querySelector(
          `div[data-gosub-plan-cycle="${currentCycle}"][data-gosub-plan-name="${currentName}"]`
        );
        if (activeDiscountDescription) {
          activeDiscountDescription.classList.remove("gosub__hidden");
        }
        setTimeout(() => {
          this._handlePriceDivChange(widget);
        }, 50);
      }
    },

    handleSellingPlanGroupChange: function (event) {
      var groupRadioEl = event.target;
      var groupId = groupRadioEl.value;
      var widget = groupRadioEl.closest(this.selectors.widget);

      var plansGroupButtons = widget.querySelectorAll(
        this.selectors.sellingPlanGroupButton
      );
      var plansContainers = widget.querySelectorAll(
        this.selectors.sellingPlansContainer
      );

      plansGroupButtons.forEach(
        function (plansGroupButton) {
          if (
            plansGroupButton.querySelector(this.selectors.sellingPlanGroupInput)
              .checked
          ) {
            plansGroupButton.classList.add(this.classes.selected);
          } else {
            plansGroupButton.classList.remove(this.classes.selected);
          }
        }.bind(this)
      );

      plansContainers.forEach(
        function (plansContainer) {
          var plansContainerGroupId =
            plansContainer.dataset.gosubSellingPlanGroupId;

          if (plansContainerGroupId === groupId && groupRadioEl.checked) {
            plansContainer.classList.remove(this.classes.hidden);
          } else {
            plansContainer.classList.add(this.classes.hidden);
          }
        }.bind(this)
      );

      // discount description change
      const discountDescriptions = document.querySelectorAll(
        ".gosub-discount-descriptions-container div"
      );
      discountDescriptions.forEach((description) => {
        description.classList.add("gosub__hidden");
      });
      const currentPlansContainer = document
        .querySelector(".gosub-widget__plan-label.active")
        .closest(".gosub-widget__plans-container");
      const currentWidget = document
        .querySelector(".gosub-widget__plan-label.active")
        .closest(".gosub-widget__plan");
      const currentCycle = currentWidget.dataset.gosubSellingPlanCycle;
      const currentName = currentWidget.dataset.gosubSellingPlanName;
      const activeDiscountDescription = currentPlansContainer.querySelector(
        `div[data-gosub-plan-cycle="${currentCycle}"][data-gosub-plan-name="${currentName}"]`
      );
      if (activeDiscountDescription) {
        activeDiscountDescription.classList.remove("gosub__hidden");
      }

      if (groupId === "once") {
        this._setSellingPlanIdInput(widget, "");
        this._handlePriceDivChange(widget);
        return;
      }

      // TODO: Implement setting for plan options vs. plan list
      // var selectedOptions = this._getSellingPlanOptions(groupId);
      // var sellingPlan = this._getSellingPlanFromOptions(groupId, selectedOptions);

      var sellingPlanId = this._getActiveSellingPlanId(widget, groupId);
      this._setSellingPlanIdInput(widget, sellingPlanId);
      this._handlePriceDivChange(widget);
    },

    handleSellingPlanGroupChangeMultipleGroup: function (event) {
      const groupSelectedId =
        document
          .querySelector("input[data-gosub-selling-plan-input]:checked")
          ?.closest(".gosub-widget__plans-container") ||
        document.querySelector(".gosub-widget__plans-container");
      const groupId = groupSelectedId.dataset.gosubSellingPlanGroupId;
      var groupRadioEl = event.target;
      var buyMethod = groupRadioEl.value;
      var widget = groupRadioEl.closest(this.selectors.widget);

      var plansGroupButtons = widget.querySelectorAll(
        this.selectors.sellingPlanGroupButton
      );
      const plansContainer = document.getElementById(
        "gosub-widget__plans-container-wrapper"
      );

      plansGroupButtons.forEach(
        function (plansGroupButton) {
          if (
            plansGroupButton.querySelector(this.selectors.sellingPlanGroupInput)
              .checked
          ) {
            plansGroupButton.classList.add(this.classes.selected);
          } else {
            plansGroupButton.classList.remove(this.classes.selected);
          }
        }.bind(this)
      );

      // discount description change
      const discountDescriptions = document.querySelectorAll(
        ".gosub-discount-descriptions-container div"
      );
      discountDescriptions.forEach((description) => {
        description.classList.add("gosub__hidden");
      });
      const currentPlansContainer = document
        .querySelector(".gosub-widget__plan-label.active")
        .closest(".gosub-widget__plans-container");
      const currentWidget = document
        .querySelector(".gosub-widget__plan-label.active")
        .closest(".gosub-widget__plan");
      const currentCycle = currentWidget.dataset.gosubSellingPlanCycle;
      const currentName = currentWidget.dataset.gosubSellingPlanName;
      const activeDiscountDescription = currentPlansContainer.querySelector(
        `div[data-gosub-plan-cycle="${currentCycle}"][data-gosub-plan-name="${currentName}"]`
      );
      if (activeDiscountDescription) {
        activeDiscountDescription.classList.remove("gosub__hidden");
      }

      if (buyMethod === "subscription") {
        plansContainer.classList.remove(this.classes.hidden);
      } else {
        plansContainer.classList.add(this.classes.hidden);
      }

      if (buyMethod === "once") {
        this._setSellingPlanIdInput(widget, "");
        this._handlePriceDivChange(widget);
        return;
      }

      // TODO: Implement setting for plan options vs. plan list
      // var selectedOptions = this._getSellingPlanOptions(groupId);
      // var sellingPlan = this._getSellingPlanFromOptions(groupId, selectedOptions);

      var sellingPlanId = this._getActiveSellingPlanId(widget, groupId);
      const activeplanGrup = document.querySelector(
        ".gosub-widget__plans-container.gosub-widget__plans-container__multiple:not(.gosub__hidden)"
      );
      if (buyMethod !== "once" && sellingPlanId && activeplanGrup) {
        // handle multiple or no active labels for group
        const activeLabelInActiveGroup = activeplanGrup?.querySelectorAll(
          ".gosub-widget__plan-label.active"
        );
        const labelsInActiveGroup = activeplanGrup?.querySelectorAll(
          ".gosub-widget__plan-label"
        );
        if (activeLabelInActiveGroup?.length > 1) {
          console.log(
            "multiple active labels in active group, remove extra actives"
          );
          for (const label of activeLabelInActiveGroup) {
            const input = label.querySelector(
              "input[data-gosub-selling-plan-input]"
            );
            if (input?.value !== sellingPlanId)
              label.classList.remove("active");
          }
        } else if (activeLabelInActiveGroup?.length == 0) {
          console.log("no active label in active group, set active one");
          for (const label of labelsInActiveGroup) {
            const input = label.querySelector(
              "input[data-gosub-selling-plan-input]"
            );
            if (input?.value == sellingPlanId) label.classList.add("active");
          }
        }

        // select first input if no input is selected in active group
        const selectedInputInActiveGroup = activeplanGrup?.querySelectorAll(
          "input[data-gosub-selling-plan-input]:checked"
        );
        if (selectedInputInActiveGroup?.length == 0) {
          const allInputs = activeplanGrup?.querySelectorAll(
            "input[data-gosub-selling-plan-input]"
          );
          if (allInputs?.length > 0) {
            allInputs[0].checked = true;
            sellingPlanId = allInputs[0].value;
            const firstLabel = allInputs[0].closest(
              ".gosub-widget__plan-label"
            );
            firstLabel.classList.add("active");
          }
        }

        // handle multiple active labels in document
        const activeLabels = document?.querySelectorAll(
          ".gosub-widget__plan-label.active"
        );
        if (activeLabels?.length > 1) {
          for (const label of activeLabels) {
            const input = label.querySelector(
              "input[data-gosub-selling-plan-input]"
            );
            if (!input?.checked) label.classList.remove("active");
          }
        }

        // handle multiple checked inputs in document
        const allActiveInputs = document?.querySelectorAll(
          "input[data-gosub-selling-plan-input]:checked"
        );
        if (allActiveInputs?.length > 1) {
          for (const input of allActiveInputs) {
            if (input.value !== sellingPlanId) {
              input.checked = false;
              const label = input.closest(".gosub-widget__plan-label");
              label.classList.remove("active");
            }
          }
        }
      }
      this._setSellingPlanIdInput(widget, sellingPlanId);
      this._handlePriceDivChange(widget);
    },

    handleSellingPlanChange: function (event) {
      var planRadioEl = event.target;
      var widget = planRadioEl.closest(this.selectors.widget);
      this._setSellingPlanIdInput(widget, planRadioEl.value);
      var labels = document.getElementsByClassName("gosub-widget__plan-label");
      for (var i = 0; i < labels.length; i++) {
        var btns = labels[i];
        btns.classList.remove("active");
      }
      planRadioEl.parentNode.classList.add("active");

      // discount description change
      const discountDescriptions = document.querySelectorAll(
        ".gosub-discount-descriptions-container div"
      );
      discountDescriptions.forEach((description) => {
        description.classList.add("gosub__hidden");
      });
      const currentPlansContainer = planRadioEl.closest(
        ".gosub-widget__plans-container"
      );
      const currentWidget = planRadioEl.closest(".gosub-widget__plan");
      const currentCycle = currentWidget.dataset.gosubSellingPlanCycle;
      const currentName = currentWidget.dataset.gosubSellingPlanName;
      const activeDiscountDescription = currentPlansContainer.querySelector(
        `div[data-gosub-plan-cycle="${currentCycle}"][data-gosub-plan-name="${currentName}"]`
      );
      if (activeDiscountDescription) {
        activeDiscountDescription.classList.remove("gosub__hidden");
      }
      this._handlePriceDivChange(widget);
    },

    handleSellingPlanChangeMultipleGroup: function (event) {
      var planRadioEl = event.target;
      if (planRadioEl.checked === true) {
        var widget = planRadioEl.closest(this.selectors.widget);
        this._setSellingPlanIdInput(widget, planRadioEl.value);
        var labels = document.getElementsByClassName(
          "gosub-widget__plan-label"
        );
        for (var i = 0; i < labels.length; i++) {
          var btns = labels[i];
          btns.classList.remove("active");
        }
        planRadioEl.parentNode.classList.add("active");
        // remove checked, if other radio is checked
        const currentPlansContainer = planRadioEl.closest(
          ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
        );
        const plansContainer = document.querySelectorAll(
          ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
        );
        plansContainer.forEach((plan) => {
          if (currentPlansContainer !== plan) {
            const otherCheckedRadio = plan.querySelector("input:checked");
            if (otherCheckedRadio) {
              otherCheckedRadio.checked = false;
            }
          }
        });

        // discount description change
        const discountDescriptions = document.querySelectorAll(
          ".gosub-discount-descriptions-container div"
        );
        discountDescriptions.forEach((description) => {
          description.classList.add("gosub__hidden");
        });
        const currentWidget = planRadioEl.closest(".gosub-widget__plan");
        const currentCycle = currentWidget.dataset.gosubSellingPlanCycle;
        const currentName = currentWidget.dataset.gosubSellingPlanName;
        const activeDiscountDescription = currentPlansContainer.querySelector(
          `div[data-gosub-plan-cycle="${currentCycle}"][data-gosub-plan-name="${currentName}"]`
        );
        if (activeDiscountDescription) {
          activeDiscountDescription.classList.remove("gosub__hidden");
        }
      }
      this._handlePriceDivChange(widget);
    },

    // NOTE: Selling Plan Options not supported in the current version of the widget...
    handleSellingPlanOptionChange: function (event) {
      var widget = event.target.closest(this.selectors.widget);

      var sellingPlanGroupId = event.target.dataset.gosubSellingPlanGroupId;
      var selectedOptions = this._getSellingPlanOptions(
        widget,
        sellingPlanGroupId
      );
      var sellingPlan = this._getSellingPlanFromOptions(
        sellingPlanGroupId,
        selectedOptions
      );
      this._setSellingPlanIdInput(sellingPlan.id);
    },

    _setSellingPlanIdInput: function (widget, sellingPlanId) {
      // create hidden input with selling plan inside product form. This input is what provides the weekly/monthly etc selling plan data to the cart
      const targetForms = findClosestElements(
        widget,
        "form[action*='/cart/add']"
      );
      if (targetForms.length === 0) {
        console.error(
          "gosub: Could not find target form at setSellingPlanIdInput"
        );
      }
      const currentPath = window.location.pathname;
      if (currentPath.includes("/product")) {
        const sellingPlanIdInput =
          document.getElementsByClassName("SellingPlanInput");
        if (sellingPlanIdInput.length == 0) {
          console.log("there is no input yet");
          const forms = document.getElementsByTagName("form");
          for (let i = 0; i < forms.length; i++) {
            if (forms[i].action.includes("/cart/add")) {
              var subscInput = document.createElement("input");
              subscInput.type = "hidden";
              subscInput.name = "selling_plan";
              subscInput.value = sellingPlanId;
              subscInput.classList.add("SellingPlanInput");
              subscInput.setAttribute("data-gosub-selling-plan-id-input", "");
              forms[i].prepend(subscInput);
            }
          }
        } else {
          for (let i = 0; i < sellingPlanIdInput.length; i++) {
            sellingPlanIdInput[i].value = sellingPlanId;
          }
        }
      } else {
        const sellingPlanIdInput =
          targetForms[0]?.querySelector(".SellingPlanInput");
        if (!sellingPlanIdInput) {
          console.log("there is no input yet");
          var subscInput = document.createElement("input");
          subscInput.type = "hidden";
          subscInput.name = "selling_plan";
          subscInput.value = sellingPlanId;
          subscInput.classList.add("SellingPlanInput");
          subscInput.setAttribute("data-gosub-selling-plan-id-input", "");
          targetForms[0]?.prepend(subscInput);
        } else {
          sellingPlanIdInput.value = sellingPlanId;
        }
      }
      var variantId = this._getVariantId(widget);

      if (
        /.*(product).*/.test(this.pageTemplate) ||
        /.*(collections).*/.test(this.pageTemplate)
      ) {
        this._updateHistoryState(variantId, sellingPlanId);
      }
    },

    _getSellingPlanGroup: function (groupId) {
      if (!this.sellingPlanGroups[groupId]) {
        console.error("gosub: Selling plan group data not found.");
        return;
      }

      return this.sellingPlanGroups[groupId];
    },

    // NOTE: Selling Plan Options not supported in the current version of the widget...
    _getSellingPlanOptions: function (widget, sellingPlanGroupId) {
      var sellingPlanOptions = widget.querySelectorAll(
        `${this.selectors.sellingPlanOption}[${this.attrs.sellingPlanGroupId}="${sellingPlanGroupId}"]:checked`
      );

      var selectedOptions = [];
      sellingPlanOptions.forEach(function (optionElement) {
        selectedOptions.push({
          index: optionElement.dataset.gosubOptionIndex,
          value: optionElement.value,
        });
      });

      return selectedOptions;
    },

    // NOTE: Selling Plan Options not supported in the current version of the widget...
    _getSellingPlanFromOptions: function (groupId, selectedOptions) {
      var sellingPlans = this._getSellingPlanGroup(groupId).selling_plans;

      var planFromOptions = sellingPlans.find(function (plan) {
        return selectedOptions.every(function (option) {
          return plan.options[option.index].value === option.value;
        });
      });

      return planFromOptions;
    },

    _getVariantId: function (widget) {
      var productForms = findClosestElements(
        widget,
        "form[action*='/cart/add']"
      );
      if (productForms.length === 0) {
        console.error("gosub: Could not find product form at getVariantId.");
      }

      for (var i = 0; i < productForms.length; i++) {
        const form = productForms[i];
        const variantIdInput = productForms[i].querySelector(
          this.selectors.variantIdInput
        );
        const formId = form?.getAttribute("id") || "unknown";
        if (
          formId &&
          typeof formId == "string" &&
          formId?.includes("ProductFormUpsell")
        ) {
          continue;
        }
        if (variantIdInput) {
          return variantIdInput.value;
        }
      }

      console.error("gosub: Could not find variant ID input at getVariantId.");
      return null;
    },

    _getActiveSellingPlanId: function (widget, groupId) {
      var activePlanInputEl = widget.querySelector(
        `input[name=gosub-selling-plan-${groupId}]:checked`
      );

      if (!activePlanInputEl) {
        console.error(
          `gosub: Could not find active plan ID for group ${groupId}.`
        );
      }

      return activePlanInputEl.value;
    },

    _updateHistoryState: function (variantId, sellingPlanId) {
      if (!history.replaceState || !variantId) {
        return;
      }

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      if (sellingPlanId) {
        params.set("selling_plan", sellingPlanId);
      } else {
        params.delete("selling_plan");
      }
      params.set("variant", variantId);

      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.toString();

      window.history.replaceState({ path: newurl }, "", newurl);
    },

    _handlePriceDivChange: function (widget) {
      const priceContainer = document.querySelector(this.selectors.priceDiv);
      const doesPriceContainerHaveRef =
        priceContainer?.getAttribute("ref") === "priceContainer";
      const doesSaleExist = priceContainer?.querySelector("compare-at-price");

      if (!priceContainer || doesPriceContainerHaveRef || !!doesSaleExist)
        return;

      const isSubscriptionOption =
        document.querySelector(
          ".gosub-widget__group.gosub__plan-selected input"
        ).value !== "once";

      if (isSubscriptionOption) {
        const discountLabelColor = document
          .querySelector(".gosub-widget__wrapper")
          .getAttribute("data-gosub-discount-label-color");

        const priceRegex = /[^\d]*\d[\d,.]*\d[^\d]*/;
        // Find the regular price
        let priceSpan = Array.from(
          priceContainer.querySelectorAll("span, sale-price")
        ).find((span) => priceRegex.test(span.textContent.trim()));

        const doesSrOnlyDivExist = priceSpan?.querySelector(".sr-only");
        if (doesSrOnlyDivExist) {
          priceSpan.removeChild(doesSrOnlyDivExist);
        }

        let selectedInput = null;
        const planContainers = document.querySelectorAll(
          ".gosub-widget__plans-container"
        );

        // Loop through containers to find the visible one
        for (const container of planContainers) {
          if (!container.classList.contains("gosub__hidden")) {
            const groupId = container.dataset.gosubSellingPlanGroupId;
            const anyChecked = container.querySelector(
              `input[name="gosub-selling-plan-${groupId}"]:checked`
            );
            if (anyChecked) {
              selectedInput = anyChecked;
              break;
            }
          }
        }
        const sellingPlanId = selectedInput?.value;

        const newPriceForActiveLabel = this._getSellingPlanAllocation(
          this._getVariantId(widget),
          sellingPlanId
        )?.per_delivery_price;
        const newPrice = newPriceForActiveLabel;
        const originalPrice = this.variants[this._getVariantId(widget)]?.price;

        const isNewPriceLowerThanOriginalPrice = newPrice < originalPrice;

        if (!isNewPriceLowerThanOriginalPrice) {
          // If new price is not lower than old, remove any strike-through and banners
          if (priceSpan && priceSpan.querySelector("s")) {
            const oldPrice = priceSpan.querySelector("s").textContent;
            priceSpan.textContent = oldPrice;
          }
          return;
        } else {
          if (priceSpan && priceSpan.querySelector("s")) {
            const newPrice = this._formatPrice(
              this._getSellingPlanAllocation(
                this._getVariantId(widget),
                sellingPlanId
              )?.per_delivery_price
            );
            const banner = priceSpan.querySelector(".gosub-new-price-banner");
            if (banner) {
              banner.textContent = newPrice;
            }

            const activeLabel = widget.querySelector(
              ".gosub-widget__plan-label.active"
            );
            const discountDiv = activeLabel.querySelector(".gosub-pricing-off");

            const oldDiscountDivCopy = priceSpan.querySelector(
              ".gosub-pricing-off-price-div"
            );
            if (oldDiscountDivCopy) {
              priceSpan.removeChild(oldDiscountDivCopy);
            }

            const discountDivCopy = discountDiv.cloneNode(true);

            discountDivCopy.style.color = "white";
            discountDivCopy.style.padding = "2px 10px 4px";
            discountDivCopy.style.backgroundColor =
              discountLabelColor || "black";
            discountDivCopy.style.borderRadius = "50px";
            discountDivCopy.style.fontSize = "0.8em";
            discountDivCopy.classList.add("gosub-pricing-off-price-div");
            discountDivCopy.style.position = "relative";
            discountDivCopy.style.top = "-2px";

            priceSpan.appendChild(discountDivCopy);
          } else if (priceSpan) {
            // Strike-through the old price
            const oldPrice = document.createElement("s");
            oldPrice.textContent = priceSpan.textContent;
            priceSpan.textContent = "";
            priceSpan.appendChild(oldPrice);

            // Add new price banner
            const newDivPrice = this._formatPrice(newPrice);

            const banner = document.createElement("span");
            banner.classList.add("gosub-new-price-banner");
            banner.textContent = newDivPrice;
            banner.style.marginRight = "6px";
            banner.style.fontWeight = "bold";
            banner.style.marginLeft = "4px";

            priceSpan.appendChild(banner);
            const activeLabel = widget.querySelector(
              ".gosub-widget__plan-label.active"
            );
            const discountDiv = activeLabel.querySelector(".gosub-pricing-off");

            const discountDivCopy = discountDiv.cloneNode(true);

            discountDivCopy.style.color = "white";
            discountDivCopy.style.padding = "2px 10px 4px";
            discountDivCopy.style.backgroundColor =
              discountLabelColor || "black";
            discountDivCopy.style.borderRadius = "50px";
            discountDivCopy.style.fontSize = "0.8em";
            discountDivCopy.classList.add("gosub-pricing-off-price-div");
            discountDivCopy.style.position = "relative";
            discountDivCopy.style.top = "-2px";

            priceSpan.appendChild(discountDivCopy);
          }
        }
      } else {
        // If not subscription option, remove any strike-through and banners
        const priceRegex = /[^\d]*\d[\d,.]*\d[^\d]*/;
        let priceSpan = Array.from(
          priceContainer.querySelectorAll("span, sale-price")
        ).find((span) => priceRegex.test(span.textContent.trim()));

        const doesSrOnlyDivExist = priceSpan?.querySelector(".sr-only");

        if (doesSrOnlyDivExist) {
          priceSpan.removeChild(doesSrOnlyDivExist);
        }

        if (priceSpan && priceSpan.querySelector("s")) {
          const oldPrice = priceSpan.querySelector("s").textContent;
          priceSpan.textContent = oldPrice;
        }
      }
    },

    /**
     * SellingPlanAllocation is the the information of how a selling plan applies to a
     * specific variant.
     */

    _getSellingPlanAllocation(variantId, sellingPlanId) {
      var variant = this.variants[variantId];
      if (!variant) {
        console.error(`gosub: Could not find variant ID ${variantId}`);
        return null;
      }
      return variant.selling_plan_allocations.find(function (plan) {
        return `${plan.selling_plan_id}` === sellingPlanId;
      });
    },

    _formatPrice(cents, format) {
      var moneyElement = document.querySelector(this.selectors.moneyFormat);
      var moneyFormat = moneyElement
        ? moneyElement.getAttribute("data-gosub-money-format")
        : null;

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString =
        format ||
        moneyFormat ||
        theme.moneyFormat ||
        theme.strings.moneyFormat ||
        Shopify.money_format ||
        "$ {% raw %}{{ amount }}{% endraw %}";

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },

    _checkPlanLimit(widget) {
      const goSubWidget = widget?.querySelector(".gosub-widget__wrapper");
      const shopUrl = document.querySelector(
        "input[data-gosub-shop-url]"
      ).value;
      fetch(`${shopUrl}/apps/gosubscride/api/check-plan-limit`)
        .then((response) => response.json())
        .then((data) => {
          console.log("data", data);
          const isOverLimit = data?.overLimit || false;
          if (isOverLimit && goSubWidget) {
            goSubWidget.classList.add("gosub__hidden");
            const sellingPlanInput = document?.querySelectorAll(
              'input[name="selling_plan"]'
            );
            for (let i = 0; i < sellingPlanInput?.length; i++) {
              sellingPlanInput[i].value = "";
            }
          }
        })
        .catch((error) => {
          console.log("Plan check error:", error);
        });
    },

    _translateContent(widget) {
      const locale = document.querySelector("input[data-gosub-locale]").value;
      const shopUrl = document.querySelector(
        "input[data-gosub-shop-url]"
      ).value;
      const goSubWidget = widget.querySelector(".gosub-widget__wrapper");
      fetch(`${shopUrl}/apps/gosubscride/api/translations`)
        .then((response) => response.json())
        .then((data) => {
          const pricingDivs = widget.querySelectorAll(".gosub-pricing-off");
          const translationObject = data?.translationObject;
          const shopTranslation = translationObject?.[locale];
          if (shopTranslation) {
            pricingDivs?.forEach((div) => {
              const pricingType = div.getAttribute("data-gosub-discount-type");
              const pricingValue = div.getAttribute(
                "data-gosub-discount-value"
              );
              const pricingPercentage = div.getAttribute(
                "data-gosub-discount-percentage"
              );
              let discountMessage = "";
              const fixedAmountMessage =
                shopTranslation?.productPageDiscountAmount;
              const percentageMessage =
                shopTranslation?.productPageDiscountPercent;
              if (pricingType == "fixed_amount" && fixedAmountMessage) {
                const discountValue = pricingValue;
                const discountMessage = fixedAmountMessage?.replace(
                  "{money}",
                  discountValue
                );
                div.innerHTML = discountMessage;
              } else if (pricingType == "price") {
                div.innerHTML = pricingValue;
              } else if (pricingType == "percentage" && percentageMessage) {
                const discountPercentage = pricingPercentage;
                const discountMessage = percentageMessage?.replace(
                  "{num}",
                  discountPercentage
                );
                div.innerHTML = discountMessage;
              }
            });
            const purchaseOptionSubscription = document?.querySelector(
              ".go-sub-purchase-option-subscription"
            );
            const purchaseOptionSubscriptionMessage =
              shopTranslation?.productPageSubscription;
            const purchaseOptionOneTime = document?.querySelector(
              ".go-sub-purchase-option-one-time"
            );
            const purchaseOptionOneTimeMessage =
              shopTranslation?.productPageOneTimePurchase;
            if (
              purchaseOptionSubscriptionMessage &&
              purchaseOptionSubscription
            ) {
              purchaseOptionSubscription.innerHTML =
                purchaseOptionSubscriptionMessage;
            }
            if (purchaseOptionOneTimeMessage && purchaseOptionOneTime) {
              purchaseOptionOneTime.innerHTML = purchaseOptionOneTimeMessage;
            }
          } else {
            console.log("No translation found");
          }
          goSubWidget.classList.remove("go-sub-translation-no-display");
        })
        .catch((error) => {
          console.log("Translation error:", error);
          goSubWidget.classList.remove("go-sub-translation-no-display");
        });
    },
  });

  return GoSubWidget;
})();

document.addEventListener("DOMContentLoaded", function () {
  window.GORIDE = window.GORIDE || {};
  window.GORIDE.GoSubWidget = new GoSubWidget();
  window.GORIDE.GoSubWidget.init();
});

// return [element, element2] domの近いものから配列で返す
function findClosestElements(element, targetQuery) {
  // まず、element自体とその祖先要素の中から探す
  let closest = element.closest(targetQuery);
  if (closest) return [closest];

  // 見つからなかった場合、documentのルートから探す
  const allElements = Array.from(document.querySelectorAll(targetQuery));
  if (allElements.length === 0) return [];

  // elementからの相対的な位置を計算して要素をソートする
  return allElements
    .map((targetElement) => {
      const position = element.compareDocumentPosition(targetElement);
      let distance;

      if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        distance = 0; // targetElementがelementの子孫の場合
      } else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
        distance = 1; // targetElementがelementの祖先の場合
      } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
        distance = 3; // targetElementがelementの後に来る場合
      } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
        distance = 4; // targetElementがelementの前に来る場合
      } else {
        distance = 5; // その他の場合（最も遠い）
      }

      return { element: targetElement, distance };
    })
    .sort((a, b) => a.distance - b.distance)
    .map((item) => item.element);
}

const quickAddDiv = document.querySelector(".quick-add.no-js-hidden");

if (quickAddDiv) {
  console.log("Quick Add exists → running GoSub code");

  const waitForModal = setInterval(() => {
    const modal = document.querySelector(".product-quick-view__content");

    if (!modal) return;

    clearInterval(waitForModal);

    function initGoSubInModal() {
      const block = modal.querySelector("[data-gosub-product]");
      if (block && !block.dataset.gosubInitialized) {
        block.dataset.gosubInitialized = "true";
        console.log("Running GoSub init inside modal");

        window.GORIDE = window.GORIDE || {};
        window.GORIDE.GoSubWidget = new GoSubWidget();
        window.GORIDE.GoSubWidget.init();
      }
    }

    initGoSubInModal();

    const observer = new MutationObserver(() => {
      initGoSubInModal();
    });

    observer.observe(modal, { childList: true, subtree: true });
  }, 200);
} else {
  console.log("Quick Add div not found → skipping GoSub code");
}
